import React from "react"

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const LoadingIndicatorIcon = props => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12.5" cy="12.5" r="9.75" stroke="#EFF2F7" strokeWidth="4.5" />
    <mask id="path-2-inside-1_1016_5454" fill="white">
      <path d="M20.1114 18.6028C21.0784 19.3781 22.5126 19.2293 23.0946 18.1351C23.8488 16.7171 24.3143 15.1553 24.4548 13.5401C24.6606 11.1757 24.1605 8.80335 23.018 6.72309C21.8754 4.64284 20.1416 2.94811 18.0359 1.85321C16.5975 1.10531 15.0297 0.660235 13.4285 0.535965C12.1928 0.440065 11.2977 1.57064 11.4333 2.80259C11.5688 4.03454 12.6954 4.88914 13.9127 5.12221C14.624 5.25842 15.3158 5.49752 15.9654 5.83528C17.2835 6.52067 18.3688 7.58154 19.0841 8.88375C19.7993 10.186 20.1123 11.671 19.9835 13.1511C19.9201 13.8805 19.7507 14.5926 19.484 15.266C19.0277 16.4183 19.1445 17.8275 20.1114 18.6028Z" />
    </mask>
    <path
      d="M20.1114 18.6028C21.0784 19.3781 22.5126 19.2293 23.0946 18.1351C23.8488 16.7171 24.3143 15.1553 24.4548 13.5401C24.6606 11.1757 24.1605 8.80335 23.018 6.72309C21.8754 4.64284 20.1416 2.94811 18.0359 1.85321C16.5975 1.10531 15.0297 0.660235 13.4285 0.535965C12.1928 0.440065 11.2977 1.57064 11.4333 2.80259C11.5688 4.03454 12.6954 4.88914 13.9127 5.12221C14.624 5.25842 15.3158 5.49752 15.9654 5.83528C17.2835 6.52067 18.3688 7.58154 19.0841 8.88375C19.7993 10.186 20.1123 11.671 19.9835 13.1511C19.9201 13.8805 19.7507 14.5926 19.484 15.266C19.0277 16.4183 19.1445 17.8275 20.1114 18.6028Z"
      stroke="var(--color-primary-blue)"
      strokeWidth="7.5"
      mask="url(#path-2-inside-1_1016_5454)"
    />
  </svg>
)
